export const CHECKOUT_URL = "https://hemodynamic-en.impultienda.ar/checkout/";
export const MOCKUP_URL = "https://cdn.magicpatterns.com/uploads/fRZjYyzRCSFAizGTwEw36y/MOCKUP_HEMODYNAMIC-EN.png";
export const CREATOR_PHOTO_URL = "https://cdn.magicpatterns.com/uploads/uaMhVqwUX4R2qcf6Wgr93n/Rachel_Bennett_-_NURSING.png";
export const PRICE = "$27";
export const REFERENCE_PRICE = "$237";
